// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responsive-data-table_previous .page-link,
.responsive-data-table_next .page-link{
    background: #e9ecef;
}
.pagination .page-item:last-child .page-link {
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
}
.pagination .page-item:first-child .page-link {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
}
div.dataTables_wrapper div.dataTables_length, div.dataTables_wrapper div.dataTables_filter{
    width: 90%;
}
div.dataTables_wrapper div.dataTables_length label{
    margin-top: 8px;
}
div.dataTables_wrapper div.dataTables_length select{
    box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Pagination/Pagination.css"],"names":[],"mappings":"AAAA;;IAEI,mBAAmB;AACvB;AACA;IACI,6CAA6C;IAC7C,gDAAgD;AACpD;AACA;IACI,4CAA4C;IAC5C,+CAA+C;AACnD;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".responsive-data-table_previous .page-link,\n.responsive-data-table_next .page-link{\n    background: #e9ecef;\n}\n.pagination .page-item:last-child .page-link {\n    border-top-right-radius: var(--border-radius);\n    border-bottom-right-radius: var(--border-radius);\n}\n.pagination .page-item:first-child .page-link {\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n}\ndiv.dataTables_wrapper div.dataTables_length, div.dataTables_wrapper div.dataTables_filter{\n    width: 90%;\n}\ndiv.dataTables_wrapper div.dataTables_length label{\n    margin-top: 8px;\n}\ndiv.dataTables_wrapper div.dataTables_length select{\n    box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
